module.exports = __webpack_public_path__ + "static/media/paintbrush.fd0604f7.png";